import React from "react";
import { Link } from "react-router-dom";
import {
  FaFacebookF,
  FaTwitter,
  FaLinkedinIn,
  FaInstagram,
} from "react-icons/fa";

import logo from "../../assets/logo.png";
import mPesa from "../../assets/m-pesa.png";
import bakaal from "../../assets/bakaal.png";
import mastercard from "../../assets/master-card.png";
import visa from "../../assets/visa.png";

function Contact(props) {
  return (
    <div className="col-12 col-md-5 col-lg-4">
      <div className="">
        <div className="bg-primary mb-3">
          <Link className="navbar-brand" to="/">
            Logo
          </Link>
        </div>
        <p>
          <span className="d-block">5 Red Lion Court, Alexandra Road,</span>
          <span className="d-block">Hounslow, England, MW3 5KJ</span>
        </p>
        <div>
          <h4 className="fs-4 mb-3">Contact us</h4>
          <p>
            <a
              className="text-decoration-none text-dark"
              href="mailto:support@tanaad.com"
            >
              Email: support@tanaad.com
            </a>
          </p>
          <p>
            <a
              className="text-decoration-none text-dark"
              href="tel: 02030703009"
            >
              Call us on: 0203 070 3009
            </a>
          </p>
        </div>
        <div className="mt-4">
          <div className="d-flex me-3">
            <Link
              to="/"
              className="box-size-45 border border-primary-dark dark-primary-20 rounded-circle text-decoration-none d-flex align-items-center justify-content-center p-2 me-2"
            >
              <FaFacebookF />
            </Link>
            <Link
              to="/"
              className="box-size-45 border border-primary-dark text-info rounded-circle text-decoration-none d-flex align-items-center justify-content-center p-2 me-2"
            >
              <FaTwitter />
            </Link>
            <Link
              to="/"
              className="box-size-45 border border-primary-dark dark-primary-20 rounded-circle text-decoration-none d-flex align-items-center justify-content-center p-2 me-2"
            >
              <FaLinkedinIn />
            </Link>
            <Link
              to="/"
              className="box-size-45 border border-primary-dark text-danger rounded-circle text-decoration-none d-flex align-items-center justify-content-center p-2 me-2"
            >
              <FaInstagram />
            </Link>
          </div>
        </div>
        <div className="d-flex my-3">
          <div className="border width-62 height-38 px-2 me-1 d-flex align-items-center justify-content-center">
            <img src={mPesa} alt="Mpesa" className="img-fluid" />
          </div>
          <div className="border width-62 height-38 px-2 me-1 d-flex align-items-center justify-content-center">
            <img src={bakaal} alt="Bakaal" className="img-fluid" />
          </div>
          <div className="border width-62 height-38 px-2 me-1 d-flex align-items-center justify-content-center">
            <img src={mastercard} alt="Mastercard" className="img-fluid" />
          </div>
          <div className="border width-62 height-38 px-2 me-1 d-flex align-items-center justify-content-center">
            <img src={visa} alt="Visa" className="img-fluid" />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Contact;
